import DocumentType from 'documents/DocumentType'
import { WorkAPI } from '../API'
import { SubmitDocumentRequestInput } from '@taxfyle/api-internal/internal/document_request_pb'
import { Id } from 'types/definitions'

export default class DocumentRequestStore {
  constructor(private workApi: WorkAPI) {}

  /**
   * Submits a document request for a job.
   *
   * @param types
   */
  async submitDocumentRequest(jobId: Id, types: DocumentType[]) {
    const ids = types
      .map((t) => t.shortId?.toString())
      .filter((id) => id !== undefined)

    const request = new SubmitDocumentRequestInput()
    await this.workApi.documentRequests.submitDocumentRequest(
      request.setRequestedIdsList(ids).setJobId(Id.assert(jobId)),
    )
  }
}
